/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { UsersBaseService } from '../users-base-service';
import { UsersApiConfiguration } from '../users-api-configuration';
import { UsersStrictHttpResponse } from '../users-strict-http-response';

import { internalNotificationsControllerResolveRecipients } from '../fn/internal/internal-notifications-controller-resolve-recipients';
import { InternalNotificationsControllerResolveRecipients$Params } from '../fn/internal/internal-notifications-controller-resolve-recipients';
import { UsersResolveRecipientsResponseDto } from '../models/users-resolve-recipients-response-dto';

@Injectable({ providedIn: 'root' })
export class UsersInternalService extends UsersBaseService {
  constructor(config: UsersApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `internalNotificationsControllerResolveRecipients()` */
  static readonly InternalNotificationsControllerResolveRecipientsPath = '/o2-users/internal/notifications/resolve-recipients';

  /**
   * Resolve notification recipients by user IDs or role (internal).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `internalNotificationsControllerResolveRecipients()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  internalNotificationsControllerResolveRecipients$Response(params: InternalNotificationsControllerResolveRecipients$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersResolveRecipientsResponseDto>> {
    const obs = internalNotificationsControllerResolveRecipients(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Resolve notification recipients by user IDs or role (internal).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `internalNotificationsControllerResolveRecipients$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  internalNotificationsControllerResolveRecipients(params: InternalNotificationsControllerResolveRecipients$Params, context?: HttpContext): Observable<UsersResolveRecipientsResponseDto> {
    const resp = this.internalNotificationsControllerResolveRecipients$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<UsersResolveRecipientsResponseDto>): UsersResolveRecipientsResponseDto => r.body)
    );
  }

}
